import { ColumnsType } from '@agro-club/agroclub-shared'
import { DASH } from 'modules/constants'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'
import { CellRenders } from 'views/components/Table/renderers'
import { KeyEntityIcon, UserHasDealsIcon } from 'views/components/TooltipIcons/TooltipIcons'
import { TruncatedValue } from 'views/components/TruncatedValue/TruncatedValue'
import CompanyRoutes from 'views/pages/Company/routes'
import UserRoutes from 'views/pages/User/routes'
import { EntityWithIconsWrapper } from 'views/styled/common'
import { TableTextLink } from 'views/ui/TableTextLink/TableTextLink'

export const useUserWithoutBidsColumns = (): ColumnsType<any> => {
  const { t } = useTranslation('dashboard')

  return useMemo(
    () => [
      {
        title: t('lastBidDate'),
        width: 150,
        dataIndex: 'last_bid_date',
        render: CellRenders.date,
      },
      {
        title: t('days'),
        width: 70,
        dataIndex: 'days_since_last_bid',
        sorter: true,
      },
      {
        title: t('user'),
        width: 400,
        dataIndex: 'id',
        render: (id, row) => (
          <EntityWithIconsWrapper>
            <TruncatedValue hint={row.full_name}>
              <TableTextLink id="user" tableItemId={id} to={generatePath(UserRoutes.Details, { id })}>
                {row.full_name || DASH}
              </TableTextLink>
            </TruncatedValue>
            <KeyEntityIcon isVisible={row.is_significant} />
            <UserHasDealsIcon isVisible={row.has_shipped_deals} />
          </EntityWithIconsWrapper>
        ),
      },
      {
        title: t('company'),
        width: 290,
        dataIndex: 'company',
        render: (company) =>
          company ? (
            <EntityWithIconsWrapper>
              <TruncatedValue hint={company.name}>
                <TableTextLink
                  id="company"
                  tableItemId={company.id}
                  to={generatePath(CompanyRoutes.Details, { id: company.id })}
                >
                  {company.name}
                </TableTextLink>
              </TruncatedValue>
            </EntityWithIconsWrapper>
          ) : (
            DASH
          ),
      },
      {
        title: t('executor'),
        width: 172,
        dataIndex: 'responsible_coordinator_short_name',
      },
      {
        title: t('team'),
        width: 112,
        dataIndex: 'team',
        render: (team) => team?.name,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t],
  )
}
